import { css } from '@reown/appkit-ui';
export default css `
  :host {
    display: block;
    width: inherit;
  }
`;
//# sourceMappingURL=styles.js.map